import React, { useEffect, useState } from "react";
import { Amplify, Auth } from "aws-amplify";
import { USER_AUTH_CONFIG } from "../aws-config";
import { Button, Space } from "antd";
import { useHistory, useLocation } from "react-router-dom";
import theme from "../theme";

const UserLink = () => {
  const history = useHistory();
  const location = useLocation();
  const [status, setStatus] = useState("");
  const [orgInfo, setOrgInfo] = useState(null);

  useEffect(() => {
    setStatus("loading");
    Amplify.configure(USER_AUTH_CONFIG);

    // Extract the 'org' query parameter from the URL
    const queryParams = new URLSearchParams(location.search);
    const orgId = queryParams.get("org");

    if (orgId) {
      fetchOrgInfo(orgId);
    } else {
      setStatus("error");
    }
  }, [location.search]);

  const fetchOrgInfo = async orgId => {
    try {
      const response = await fetch(`/org/info?id=${orgId}`);
      if (response.ok) {
        const data = await response.json();
        setOrgInfo(data);
        setStatus("loaded");
      } else {
        setStatus("error");
      }
    } catch (error) {
      console.error("Error fetching org info:", error);
      setStatus("error");
    }
  };

  const handleLink = () => {
    if (orgInfo) {
      history.push(orgInfo.oauthUrl); // Redirect to the org's OAuth URL
    }
  };

  const handleLogout = async () => {
    await Auth.signOut();
    history.push("/user-login"); // Navigate to '/user-login' after logout
  };

  return (
    <>
      {status === "loaded" && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "100vh",
            textAlign: "center",
            padding: "0 16px",
            backgroundColor: theme.palette.background.l1,
          }}
        >
          <h5 style={{ marginBottom: 16, fontSize: "1.5rem", fontWeight: 500 }}>
            {`Your Meow Home account is not linked to ${orgInfo.name}`}
          </h5>
          <p style={{ marginBottom: 16, fontSize: "1rem" }}>
            Please choose one of the options below to proceed.
          </p>
          <Space size="middle" style={{ marginTop: 32 }}>
            <Button type="primary" onClick={handleLogout}>
              Switch Account
            </Button>
            <Button
              type="default"
              onClick={handleLink}
              disabled={!orgInfo}
            >
              Start Linking
            </Button>
          </Space>
        </div>
      )}
      {status === "error" && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "100vh",
            textAlign: "center",
            padding: "0 16px",
            backgroundColor: theme.palette.background.l1,
          }}
        >
          <h5 style={{ marginBottom: 16, fontSize: "1.5rem", fontWeight: 500 }}>
            Failed to access organization info.
          </h5>
        </div>
      )}
    </>
  );
};

export default UserLink;
